module.exports = __webpack_public_path__ + "img/Download_on_the_App_Store_Badge_DE_RGB_blk_092917.065b98f1.png";